import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1>Aus Chaos wird Klarheit. Aus Betrieb wird Wirkung.</h1>
        <p>
          Wir helfen Ihnen, den Gebäudebetrieb zu entschlacken – mit stabilen Prozessen, digitalen Tools und einer Beratung, die Ihr Team stärkt, statt es zu überfordern.
        </p>
        <Link to="/contact" className="btn">
          Jetzt kostenfreie Ersteinschätzung anfragen
        </Link>
      </div>
    </section>
  );
}

export default Hero;
